import { useTheme } from "@mui/material";
import BackgroundImageCst from "@components/BackgroundImageCst";
import Breadcrumb from "@components/Breadcrumb";
import HeroCst from "@components/HeroCst";
import ModalConfirmsCst from "@components/ModalConfirmsCst";
import { StatusEnum } from "@components/ModalConfirmsCst/types";
import { Box, Container } from "@mui/material";
import { PagesID } from "@utils/utilsConfigurations";
import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { getCookie } from "@utils/utilsCookie";
import { useParams } from "react-router-dom";
import ButtonBackPage from "@components/ButtonBackPage";
import { useFetchDataDetail } from "@hooks/useFetchDetail";
import { ServicesURL } from "@utils/utilsApi";
import { useTranslateInput } from "@hooks/useTranslateInput";

const EditSurvey: React.FC<{ page: PagesID }> = ({ page }) => {
  const theme = useTheme();
  const { t } = useTranslation(["survey"]);
  const sessionId = getCookie("sessionId") || "";
  const { surveyId, id } = useParams();

  const [openToast, setOpenToast] = useState<{
    s: StatusEnum;
    message: string;
  }>();

  useEffect(() => {
    window.onmessage = function (e) {
      if (e.data.type === "SurveyEvent") {
        switch (e.data.data.code) {
          case 400:
            setOpenToast({ s: StatusEnum.KO, message: e.data.data.message });
            break;
          case 200:
            setOpenToast({ s: StatusEnum.OK, message: "" });
            break;
        }
      }
    };

    window.onmessage = function (e) {
      if (e.data === "UpdateSurvey") {
        handleHeight();
      }
    };
  }, []);

  const handleHeight = () => {
    setTimeout(() => {
      const iframe = document.querySelector("iframe");
      const iframeHeight = iframe?.contentWindow?.document.body.scrollHeight;
      if (!!iframeHeight && iframeHeight > 0) {
        iframe && iframe.setAttribute("height", `${iframeHeight}px`);
      }
    }, 500);
  };

  const { dataDetail: languagesData } = useFetchDataDetail(
    `${ServicesURL.corporateLanguages.replace(":corporateId", id!.toString())}`,
  );

  const languages = useTranslateInput(languagesData);

  const languageLabels = useMemo(() => {
    const map: Record<string, string> = {};
    (languages?.secondary_languages || []).forEach(
      (lang: { id: string; label: string }) => {
        map[lang.id] = lang.label;
      },
    );
    return map;
  }, [languages]);

  const languageOptions = Object.entries(languageLabels);

  const [selectedLang, setSelectedLang] = useState("");

  const hasSecondaryLanguages =
    languageLabels && Object.keys(languageLabels).length > 0;

  const iframeSrc = selectedLang
    ? `${process.env.REACT_APP_SURVEY_URL}?sessionId=${sessionId}&surveyModelId=${surveyId}&translate=${selectedLang}`
    : `${process.env.REACT_APP_SURVEY_URL}?sessionId=${sessionId}&surveyModelId=${surveyId}`;

  return (
    <>
      <BackgroundImageCst
        customWidth={"100%"}
        customHeight={"603px"}
        image="section-survey.jpg"
        position={"absolute"}
        fullpage={true}
      />
      <Breadcrumb />
      <Container
        maxWidth={"xxl"}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <HeroCst
          title={t("edit.hero-title")}
          description={t("edit.hero-description")}
        />
        <ButtonBackPage />
        <Box
          sx={{
            mt: "25px",
            "& iframe": {
              border: 0,
            },
          }}
        >
          {hasSecondaryLanguages && (
            <select
              className="mail-editor-lang-select"
              value={selectedLang}
              onChange={(e) => setSelectedLang(e.target.value)}
              title={t("change-template-language")}
              style={{
                backgroundColor: theme.palette.background.paper,
                color: theme.palette.text.primary,
                borderColor: theme.palette.divider,
                display: "inline-flex",
                alignItems: "center",
                height: "auto",
                padding: "0.5rem 1rem",
                marginRight: theme.spacing(1),
                fontSize: "1rem",
                fontWeight: "400",
                borderWidth: "1px",
                borderStyle: "solid",
                borderRadius: theme.spacing(0.5),
                cursor: "pointer",
                marginBottom: theme.spacing(3.125),
                minWidth: "200px",
              }}
            >
              <option value={""}>{t("main-template")}</option>
              {languageOptions.map(([key, val]) => (
                <option key={key} value={key}>
                  {val || key.toUpperCase()}
                </option>
              ))}
            </select>
          )}
          <iframe
            src={iframeSrc}
            width={"100%"}
            title="iframe"
            onLoad={handleHeight}
          ></iframe>
        </Box>
      </Container>
      <ModalConfirmsCst
        open={!!openToast}
        title={t("edit-hero-title")}
        description={""}
        onCallBackClosed={() => {
          setOpenToast(undefined);
        }}
        status={openToast}
      />
    </>
  );
};

export default EditSurvey;
